import React from "react"

import { type IconProps } from "./utils"

export default function SlideIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.62803 3.75C4.93691 2.87611 5.77034 2.25 6.75 2.25H11.25C12.2297 2.25 13.0631 2.87611 13.372 3.75H14.25C15.4926 3.75 16.5 4.75736 16.5 6V12C16.5 13.2426 15.4926 14.25 14.25 14.25H13.372C13.0631 15.1239 12.2297 15.75 11.25 15.75H6.75C5.77034 15.75 4.93691 15.1239 4.62803 14.25H3.75C2.50736 14.25 1.5 13.2426 1.5 12V6C1.5 4.75736 2.50736 3.75 3.75 3.75H4.62803ZM4.5 5.25H3.75C3.33579 5.25 3 5.58579 3 6V12C3 12.4142 3.33579 12.75 3.75 12.75H4.5V5.25ZM13.5 12.75H14.25C14.6642 12.75 15 12.4142 15 12V6C15 5.58579 14.6642 5.25 14.25 5.25H13.5V12.75ZM6.75 3.75C6.33579 3.75 6 4.08579 6 4.5V13.5C6 13.9142 6.33579 14.25 6.75 14.25H11.25C11.6642 14.25 12 13.9142 12 13.5V4.5C12 4.08579 11.6642 3.75 11.25 3.75H6.75Z"
        fill="currentColor"
      />
    </svg>
  )
}
